import { EducatorPageChrome } from "@/pages/educators/page-chrome"
import { useId } from "react"

import { PageBody } from "@/components/ui/layout"
import { SaveButton } from "@/components/shared/action-buttons"

import ListingProfileForm from "./form"
import { UpdateParams } from "./page-props"
import { useNavigate } from "@/lib/page-rendering"

export default function Edit() {
  const navigate = useNavigate()
  const formId = useId()
  const titleId = useId()
  const onSubmit = (data: UpdateParams) => {
    navigate({
      href: ".",
      method: "put",
      data,
      formData: true,
    })
  }

  return (
    <>
      <EducatorPageChrome
        titleId={titleId}
        action={<SaveButton form={formId} />}
      />
      <PageBody>
        <ListingProfileForm
          formId={formId}
          titleId={titleId}
          onSubmit={onSubmit}
          registerDirtyDraft
        />
      </PageBody>
    </>
  )
}
